// Critical-fields contract — see aegle-docs critical_fields_contract.md
import { ClaimantCreate } from "@/types";
import { validateNotFutureDate, validateRequired, validateAge } from "../helpers/validationHelpers";

export const validateClaimants = (values: ClaimantCreate): Record<string, string> => {
  const errors: Record<string, string> = {};

  // --- Required Top-Level Fields (per backend validation) ---
  validateRequired(values.client_id_ref, "client_id_ref", errors);
  validateRequired(values.claimant_first_name, "claimant_first_name", errors);
  validateRequired(values.claimant_last_name, "claimant_last_name", errors);

  // Note: Gender, birth_date, and relationship are optional per backend (omitempty)
  // but we may want to require them for business logic reasons

  // --- Age Validation ---
  if (values.claimant_age !== undefined) {
    validateAge(values.claimant_age, "claimant_age", errors);
  }

  // --- Business Logic Validations ---

  // Birth date should not be in the future
  if (values.claimant_birth_date) {
    validateNotFutureDate(
      values.claimant_birth_date,
      "claimant_birth_date",
      errors,
      "Birth date cannot be in the future"
    );
  }

  return errors;
};
